import { Button, Modal as DieterModal } from '@wework/dieter-ui'
import Row from '../Common/Row'
import React from 'react'

export default function Modal({
  open,
  title,
  content,
  confirmText,
  cancelText,
  onConfirm,
  onClose,
}) {
  return (
    <DieterModal
      style={{ width: 420, padding: 16 }}
      onClose={onClose}
      // onOpen={() => handler(true)}
      open={open}
    >
      <DieterModal.Header style={{ padding: 0 }}>
        <Row>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span
              style={{
                width: 'fit-content',
                backgroundColor: '#F0E5FF',
                color: '#2A0066',
                fontSize: 12,
              }}
            >
              {title}
            </span>
          </div>
          <Button basic onClick={onClose} icon="close" style={{}} />
        </Row>
      </DieterModal.Header>
      <DieterModal.Content>{content}</DieterModal.Content>
      <DieterModal.Actions style={{ textAlign: 'left' }}>
        <Button
          style={{ marginLeft: 0 }}
          onClick={() => {
            onConfirm()
            onClose()
          }}
          primary
        >
          {confirmText}
        </Button>
        <Button
          basic
          primary
          // disabled={submittingNote}
          // loading={submittingNote}
          onClick={onClose}
        >
          {cancelText}
        </Button>
      </DieterModal.Actions>
    </DieterModal>
  )
}
